module.exports = __webpack_public_path__ + "img/项目.ae50283c.gif";